// Mock for react-native-keyboard-controller on web
// This module doesn't work on web, so we provide no-op implementations

import React from 'react';

// Wrapper component that just renders children
export const KeyboardProvider = ({ children }) => children;

export const KeyboardAwareScrollView = ({ children, ...props }) => {
    const { View, ScrollView } = require('react-native');
    return React.createElement(ScrollView, props, children);
};

export const KeyboardStickyView = ({ children, ...props }) => {
    const { View } = require('react-native');
    return React.createElement(View, props, children);
};

export const KeyboardToolbar = ({ children, ...props }) => {
    const { View } = require('react-native');
    return React.createElement(View, props, children);
};

// Hooks
export const useKeyboardHandler = () => { };
export const useKeyboardAnimation = () => ({ height: { value: 0 }, progress: { value: 0 } });
export const useReanimatedKeyboardAnimation = () => ({ height: { value: 0 }, progress: { value: 0 } });
export const useFocusedInputHandler = () => { };
export const useKeyboardController = () => ({
    setEnabled: () => { },
    setInputMode: () => { },
    setDefaultMode: () => { },
});
export const useKeyboardContext = () => ({
    animated: { height: { value: 0 }, progress: { value: 0 } },
    isKeyboardShown: false,
});

// Default export
export default {
    KeyboardProvider,
    KeyboardAwareScrollView,
    KeyboardStickyView,
    KeyboardToolbar,
    useKeyboardHandler,
    useKeyboardAnimation,
    useReanimatedKeyboardAnimation,
    useFocusedInputHandler,
    useKeyboardController,
    useKeyboardContext,
};
